import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="mt-2">
    <div className="copyright">
      <p>
        ©
        <a href="http://www.kellogg.northwestern.edu/" target="_blank">Kellogg School of Management</a>.
        <a href="https://www.northwestern.edu/" target="_blank">Northwestern University</a> | All Rights Reserved.
        |
        <a className="privacy-link" href="https://www.kellogg.northwestern.edu/policies.aspx" target="_blank">
          Privacy
          Policy
        </a>
      </p>
    </div>
    <div className="social-icons">
      <span>
        <a className="feedback-link" href="mailto:kellogg-registrar@kellogg.northwestern.edu">
          <i className="fa fa-envelope"></i>
          Comments?
        </a>
      </span>
      <span>
        <a href="https://www.facebook.com/KelloggSchool" target="_blank">
          <i className="fa fa-facebook-square"></i>
        </a>
      </span>
      <span>
        <a href="https://plus.google.com/+KelloggSchool" target="_blank">
          <i className="fa fa-google-plus"></i>
        </a>
      </span>
      <span>
        <a href="http://www.linkedin.com/company/3195?trk=tyah" target="_blank">
          <i className="fa fa-linkedin"></i>
        </a>
      </span>
      <span>
        <a href="http://Kelloggschool.tumblr.com/" target="_blank">
          <i className="fa fa-tumblr"></i>
        </a>
      </span>
      <span>
        <a href="http://twitter.com/KelloggSchool" target="_blank">
          <i className="fa fa-twitter"></i>
        </a>
      </span>
      <span>
        <a href="http://www.youtube.com/KelloggSchool" target="_blank">
          <i className="fa fa-youtube-play"></i>
        </a>
      </span>
    </div>
  </footer>
  );
};
